// 组件路径映射：后端 component 字段 → 前端组件
const componentMap = {
  'dashboard/index': () => import('@/views/layout/Dashboard.vue'),
  'profile/index': () => import('@/views/user/Profile.vue'),
  'merchant/index': () => import('@/views/merchant/MerchantList.vue'),
  'category/index': () => import('@/views/category/CategoryList.vue'),
  'product/index': () => import('@/views/product/ProductList.vue'),
  'product/ProductForm': () => import('@/views/product/ProductForm.vue'),
  'order/OrderList': () => import('@/views/order/OrderList.vue'),
  'order/MerchantOrderList': () => import('@/views/order/MerchantOrderList.vue'),
  'system/user': () => import('@/views/user/UserList.vue'),
  'system/role': () => import('@/views/system/role/index.vue'),
  'system/menu': () => import('@/views/system/menu/index.vue'),
  'system/log/login': () => import('@/views/system/log/login.vue'),
  'system/log/operation': () => import('@/views/system/log/operation.vue'),
}

// 根据后端菜单数据动态注册路由
export function registerDynamicRoutes(menuTree) {
  const addedRoutes = []

  function processMenus(menus) {
    for (const menu of menus) {
      // 有 component 的才是叶子菜单
      if (menu.component && menu.component.trim()) {
        const componentLoader = componentMap[menu.component]
        if (componentLoader) {
          // path 以 / 开头直接用，否则加 /
          const routePath = menu.path && menu.path.startsWith('/') ? menu.path.slice(1) : menu.path

          addedRoutes.push({
            path: routePath || 'index',
            name: `dynamic_${menu.id}`,
            component: componentLoader,
            meta: { title: menu.menuName, dynamic: true }
          })
        }
      }

      // 递归处理子菜单
      if (menu.children && menu.children.length > 0) {
        processMenus(menu.children)
      }
    }
  }

  processMenus(menuTree)
  return addedRoutes
}

export { componentMap }